/* This file is autogenerated, see readme.md for instructions */
import PersAlt1SvgIcon from '@bloomreach/banana-theme/icons/pers-alt-1.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const PersAlt1Icon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <PersAlt1SvgIcon />
    </Icon>
  );
});

PersAlt1Icon.displayName = 'PersAlt1Icon';

export default PersAlt1Icon;
